import { normalizeValue } from './ValueNormalizer';

export const TrailerType = [
  '2 Jeep Dollies',
  '2 Pivoting Dollies',
  'A-Train',
  'Auto or Boat Transporter',
  'Auxiliary Dolly',
  'B-Train',
  'B-Train Semi',
  'Batch Plant',
  'Boom Dolly',
  'Booster',
  'C-Train',
  'Conveyor',
  'Conveyor Dolly',
  'Curtain-Sider',
  'Doubledrop',
  'Dropdeck',
  'Dry box/van',
  'Extendable/Trombone',
  'Fardier',
  'Farm Implement',
  'Flatbed',
  'Flip axle',
  'Float',
  'Goldhoffer',
  'In Tow',
  'In Tow Frac Tank',
  'In Tow Stacker',
  'In Tow Portable Stacker',
  'In Tow Screening Plant',
  'Jeep',
  'Jeep Dolly',
  'Joe Dog',
  'Lowboy/Lowbed',
  'Mini Deck',
  'Mobile Home in tow',
  'Multiline',
  'N/A',
  'Pin On',
  'Pivoting Booster',
  'Pivoting Dolly',
  'Pivoting Tag',
  'Push Truck',
  'Rear Steer Dolly',
  'Reefer trailer',
  'Roll Off',
  'Semi Trailer',
  'Single Drop Steering Dolly',
  'Sliding Axle',
  'Steering Dolly',
  'Stepdeck',
  'Stinger',
  'Stinger axle',
  'Stinger-steered Auto or Boat Transporter',
  'Tag axle',
  'Tanker',
  'Tow-Dolly',
  'Towaway',
  'Trailer',
] as const;

export const normalizeTrailerType = (
  type?: string | null,
): string | undefined => {
  return normalizeValue(TrailerType, type);
};
